export const flowType = {
  BUY_RECHARGES: '1',
  SEND_RECHARGES: '2'
}
